import {IEditFileMetadataFormBaseValues} from '../components/FilesEditResourceForm/config';
import {mapResourceMetadata} from './mapResourceMetadata';
import {emptyResourceMetadataLookupNames, IResourceMetadataLookupNames} from 'admin/resources/utils';

export const mapUpdateResourceWebLinkPayload = (
  fileId: string,
  formValues: IEditFileMetadataFormBaseValues,
  lookupNames: IResourceMetadataLookupNames = emptyResourceMetadataLookupNames()
) => {
  const metadata = mapResourceMetadata(formValues, lookupNames);
  return {
    id: fileId,
    displayName: formValues.displayName,
    briefDescription: formValues.briefDescription,
    url: formValues.webLink,
    filePath: formValues.link ?? '',
    metadata,
  };
};
